import { MutableRefObject, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { iframeIntegration } from '@bg-shared/integrations';

interface IProps {
    ref?: MutableRefObject<HTMLDivElement>;
    skip?: boolean;
    useIframeIntegrationVersion?: boolean;
}

export const useRestoreScrollPosition = ({
    ref,
    skip,
    useIframeIntegrationVersion,
}: IProps = {}): void => {
    const location = useLocation();

    useEffect(() => {
        if (skip) {
            return;
        }

        if (ref && !useIframeIntegrationVersion) {
            ref.current.scrollTo(0, 0);
        } else {
            iframeIntegration.scrollToRelative();
        }
    }, [location.pathname, location.search]);
};
